import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    ClientiDTOApiResponse,
    mapJsonToClientiDTOApiResponse,
    mapJsonToPrevTesta,
    mapJsonToPrevTestaDTOApiResponse,
    mapJsonToRepoPrevDettApiResponse,
    mapPrevTestaFormToJson,
    mapPrevTestaToJson,
    PrevTesta,
    PrevTestaDTOApiResponse,
    PrevTestaForm,
    RepoPrevDettApiResponse,
    DipendentiApiResponse,
    mapJsonToDipendentiApiResponse,
    DipendentiListApiResponse,
    mapJsonToDipendentiListApiResponse,
    mapJsonToVMPrevListApiResponse, VMPrevListApiResponse
} from "./types";


const moment = require('moment')



// ---------------------     PREV TESTA  -------------------
export function useGetAllPrevTestaDTObyDip(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
    flgtemp: string
) {
    return useQuery<PrevTestaDTOApiResponse>({
        queryKey: [
            'fetchPrevTestaDTObyDip',
            columnFilters, // refetch when columnFilters changes
            globalFilter,  // refetch when globalFilter changes
            pagination.pageIndex, // refetch when pagination.pageIndex changes
            pagination.pageSize, // refetch when pagination.pageSize changes
            sorting, // refetch when sorting changes
        ],
        queryFn: async () => {


            let coddip = localStorage.getItem('coddip') || 'NN';
            let impcoddip = localStorage.getItem('impcoddip') || 'NN';

            const role = localStorage.getItem('keyrole') || '';
            // let coddip = localStorage.getItem('coddip') || 'NN';


                    if (role.includes('TimeReportPreventivi')) {
                                coddip = (impcoddip === 'NN' || impcoddip === '') ? '' : impcoddip;
                            };


            const myLimit=pagination.pageSize;
            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;

            let myURL = `?limit=${myLimit}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParam(
                columnFilters,
                'VPV02'
            )}&ordering=${sortingParam(sorting, 'VPV02')}`;


             if (coddip !== '' && flgtemp == 'N') {
                        myURL += `&VPV02_CODDIP=${coddip}`;
                }


            // Fetch the data using the constructed URL
            const response = await AxiosInstance.get(
                `prevtestadto/${myURL}&VPV02_FLGTEMP=${flgtemp}`
            );

            return mapJsonToPrevTestaDTOApiResponse(response.data);
        },
        refetchOnWindowFocus: false,
    });
}

export function useGetPrevTesta(id: number = 0) {
  return useQuery<PrevTesta>({
    queryKey: ['fetchPrevTestaDTO'],
    queryFn: async () => {
      const response = await AxiosInstance.get('prevtesta/'+id+'/');

      // console.log("PREVTESTA: ",response);
      return mapJsonToPrevTesta(response.data.data.prevtesta);
    },
    refetchOnWindowFocus: false,
  });
}



export function useGetPrevTestaDTObyPrev(id: number = 0) {
  return useQuery<PrevTestaDTOApiResponse>({
    queryKey: ['fetchPrevTestaDTO'],
    queryFn: async () => {
      const response = await AxiosInstance.get('prevtestadtobyprev/'+id+'/');

      // console.log("PREVTESTA: ",response);
      return mapJsonToPrevTestaDTOApiResponse(response.data);
    },
    refetchOnWindowFocus: false,
  });
}

export function useCreatePrevTesta() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (prevtestaform: PrevTestaForm) => {
      if (prevtestaform.dataprev) {
        prevtestaform.dataprev = moment(prevtestaform.dataprev).format('YYYY-MM-DD');
      }

      return AxiosInstance.post('prevtesta/0/',mapPrevTestaFormToJson(prevtestaform));
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fetchPrevTestaDTObyDip'] }), //refetch Preventivi after mutation, disabled for demo
     });
}

export function useUpdatePrevTesta() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (prevtesta: PrevTesta) => {
      if (prevtesta.dataprev) {
        prevtesta.dataprev = moment(prevtesta.dataprev).format('YYYY-MM-DD');
      }
       return AxiosInstance.patch('prevtesta/'+prevtesta.id+'/',mapPrevTestaToJson(prevtesta));
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['fetchPrevTestaDTObyDip'] }),
  });
}

export function useDeletePrevTesta() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => {
    const response = await AxiosInstance.delete('prevtesta/'+id+'/');
     return  response
    },
     onSettled: () => queryClient.invalidateQueries({ queryKey: ['fetchPrevTestaDTObyDip'] }),
  });
}


// --------------------- FINE PREV TESTA  -------------------



//--------------------------  INIZIO VARIE -----------


export function useDuplicaPrev() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, coddip }: { id: number; coddip: string }) => {
      const response = await AxiosInstance.post('prevdup/', { id, coddip });
      return response;
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['fetchPrevTestaDTObyDip'] });
    },
  });
}


export function useGetDipByUsername(username: string) {
  return useQuery<DipendentiApiResponse>({
    queryKey: ['fetchDipendenti'],
    queryFn: async () => {
      const response = await AxiosInstance.get('dipbyusername/'+username+'/?limit=10000&offset=0');

      return mapJsonToDipendentiApiResponse(response.data)

    },
    refetchOnWindowFocus: false,
  });
}

export function useGetClientiDTO(codditta: number) {
  return useQuery<ClientiDTOApiResponse>({
    queryKey: ['fetchClientiDTO'],
    queryFn: async () => {

      //console.log('call useGetClientiDTO with:',codditta)
      const response = await AxiosInstance.get('clientidto/?limit=10000&offset=0&VPV10_CODDITTA='+codditta);

      return mapJsonToClientiDTOApiResponse(response.data)

      //const json = (response.data) as ClientiApiResponse;
      //console.log(response.data)
      // return json;
    },
    refetchOnWindowFocus: false,
  });
}

export function useGetVMPrev() {
  return useQuery<VMPrevListApiResponse>({
    queryKey: ['fetchVMPrevList'],
    queryFn: async () => {

      //console.log('call useGetClientiDTO with:',codditta)
      const response = await AxiosInstance.get('vmprev/?limit=10000&offset=0');

      return mapJsonToVMPrevListApiResponse(response.data)

      //const json = (response.data) as ClientiApiResponse;
      //console.log(response.data)
      // return json;
    },
    refetchOnWindowFocus: false,
  });
}







//mp conversione  filter parameters per django rest api
export function columnFiltersParam(columnFilters: MRT_ColumnFiltersState,pretab: string) {
  var loopData = ''
  var i;
  for (i = 0; i < columnFilters.length; i++) {
    loopData += "&"
    loopData += (`${pretab}_${columnFilters[i].id}`).toUpperCase() + "=" + `${columnFilters[i].value}`;
  }
  return loopData
}
export function sortingParam(sorting: MRT_SortingState, pretab: string) {
  let ordering = '';
  for (let i = 0; i < sorting.length; i++) {
    const { id, desc } = sorting[i];
    ordering += desc ? (`${pretab}_${id}`).toUpperCase() + ',' : (`-${pretab}_${id}`).toUpperCase() + ',';
  }
  // Remove the trailing comma
  ordering = ordering.slice(0, -1);
  return ordering;
}




export function useGetDipendentiList(ditta: number) {
  return useQuery<DipendentiListApiResponse>({
    queryKey: ['fetchDipendentiList', ditta],
    queryFn: async () => {
      let url = 'dipendentiprev/?limit=10000&offset=0&VPV30_FLGDEL=N';

      if (ditta !== 0) {
        url += `&VPV30_DITTA=${ditta}`;
      }

      const response = await AxiosInstance.get(url);
      return mapJsonToDipendentiListApiResponse(response.data);
    },
    refetchOnWindowFocus: false,
  });
}

















//--------------------------  FINE VARIE -----------


//--------------------------  INIZIO  REPO  -----------
export  function useGetRepoPrevDettByPrev(pagination: MRT_PaginationState,columnFilters:  MRT_ColumnFiltersState,globalFilter: string,sorting: MRT_SortingState, idprevtesta: number) {
  return useQuery<RepoPrevDettApiResponse>({
    queryKey: ['fetchRepoPrevDett',
       columnFilters, //refetch when columnFilters changes
       globalFilter, //refetch when globalFilter changes
       pagination.pageIndex, //refetch when pagination.pageIndex changes
       pagination.pageSize, //refetch when pagination.pageSize changes
       sorting, //refetch when sorting changes
       idprevtesta
    ],
    queryFn: async () => {

      const myOffset = (pagination.pageIndex==0) ? "0": `${pagination.pageSize*(pagination.pageIndex)}`;
      // const myURL = '?limit='+`${pagination.pageSize}`+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters)+'&ordering='+sortingParam(sorting);
      const myURL = '?limit=1000'+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters,'')+'&ordering='+sortingParam(sorting,'');
      const response = await AxiosInstance.get('repoprevdettbyprev/'+idprevtesta+'/'+myURL);


      return mapJsonToRepoPrevDettApiResponse(response.data)

    },
    refetchOnWindowFocus: false,
  });
}

//--------------------------  FINE REPO  -----------


export function useCreaProg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const data = await AxiosInstance.get('creaprog/'+id+'/');
      return data;
    },
    onSuccess: (data) => {
      // Optional: invalidate any related data
      // queryClient.invalidateQueries({ queryKey: ['fetchMonitorProgettiRiepilogo'] });
    },
  });
}


export function useGeneraAnalisiRequisiti() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (idprev: number) => {
      const response = await AxiosInstance.post(
        `generaanalisirequisiti/${idprev}/`,
        {},
        {
          responseType: 'blob', // ⬅️ IMPORTANTISSIMO
        }
      );
      return response.data;
    },
    onSuccess: (blob, idprev) => {
      // Download automatico del file
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `AnalisiRequisiti_${idprev}.docx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      // opzionale: invalida altre query
      queryClient.invalidateQueries({
        queryKey: ['fetchMonitorProgettiRiepilogo'],
      });
    },
  });
}


export async function fnCalcolaPM({  idprev}: {  idprev: number;}) {
  try {
    const response = await AxiosInstance.get(
      `fncalcolapm/${idprev}/`
    );

    return response.data;

  } catch (error) {
    console.error('Error calculating PM:', error);
    throw new Error('PM calculation failed');
  }
}